import type { CombinedComponentConfigMapT, CustomComponentsMap, InputDataT } from '@uber/atgl-components';
export type Logger = {
  error: (message: string, error?: any) => void;
  warn: (message: string) => void;
  info: (message: string) => void;
};
export type ShowNotificationFunction = (message: string, type?: 'error' | 'warning' | 'info') => void;
export enum MEDIA_TYPE {
  CONTENT_MEDIA_TYPE_VIDEO = 'CONTENT_MEDIA_TYPE_VIDEO',
  CONTENT_MEDIA_TYPE_IMAGE = 'CONTENT_MEDIA_TYPE_IMAGE',
  CONTENT_MEDIA_TYPE_TEXT = 'CONTENT_MEDIA_TYPE_TEXT',
  CONTENT_MEDIA_TYPE_AUDIO = 'CONTENT_MEDIA_TYPE_AUDIO',
  CONTENT_MEDIA_TYPE_INVALID = 'CONTENT_MEDIA_TYPE_INVALID',
}
export type GeneratedContent = {
  content: string;
  type: MEDIA_TYPE;
  contentIdentifier: string;
};
export type ProjectGenerationConfig = {
  configId: string;
};
export type AIGatewayMetadata = {
  workItemId: string;
  taskDataId: string;
  accountId: string;
  envId: string;
};
export type PromptMedia = {
  file: File;
  type: 'image' | 'video' | 'pdf';
};
export type UploadedFile = {
  uploadPath: string;
  mimeType: string;
};
export type AIGatewayFunctions = {
  startContentGeneration: (prompt: string, generationConfig?: ProjectGenerationConfig, uploadedFiles?: UploadedFile[], ingestedFiles?: {
    key: string;
    mimeType: string;
  }[]) => Promise<{
    operationId: string;
  } | Error>;
  getGeneratedContent: (operationId: string) => Promise<GeneratedContent[] | Error | undefined>;
};
export type GenAIValidationProps = {
  noOfColumnsPerRow?: number;
  componentConfigMap?: CombinedComponentConfigMapT;
  inputData?: InputDataT;
  preParseFnList?: ((inputData: CombinedComponentConfigMapT) => CombinedComponentConfigMapT)[];
  onStateChange?: (labellingData: any, validations?: any) => void;
  aiGateway?: AIGatewayFunctions;
  generationConfig?: ProjectGenerationConfig;
  logger?: Logger;
  showNotification?: ShowNotificationFunction;
  resetInputSearch?: () => void;
  hideClearBtn: boolean;
  enableMediaInput?: boolean;
  maxMediaFiles?: number;
  generationRemaining?: number;
  uploadMediaFiles: (mediaFiles: PromptMedia[]) => Promise<UploadedFile[] | Error>;
  customComponents?: CustomComponentsMap;
  hideInput?: boolean;
  initialSearchTerm?: string;
  initialGeneratedContent?: GeneratedContent[];
};